import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
//import { styled } from '@mui/material/styles';  
import { Redirect  } from 'react-router-dom';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import axios from 'axios';
import Checkbox from '@mui/material/Checkbox'; 
import SearchIcon from '@mui/icons-material/Search';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableRow from '@mui/material/TableRow';  
import TableHead from '@mui/material/TableHead';  
import TableCell from '@mui/material/TableCell'; 
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import AddCategory from './AddCategory';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';




const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)

export default class AdminCategory extends Component {
	constructor(props){
    super();
this.state = {
logredirect:false,pagename:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],
	 search:'',id:'',order:'desc' ,orderBy:'ca_id',categorydata:[],ca_id:0,
	btndisabled:false,StoreData:[],redirect: false,details:'',
userdata:[],name:'',categoryarray:[],maincategory:0,maincategory:'',category:'',namesearch:'',
submitbtn:"Submit", searchbtn:"search",searchbtndisabled:false,rightpanel:false,
      }
	   this.updatecategoryParent = this.updatecategoryParent;
	 };
	 
	 updatecategoryParent = (text) => {this.apicall(this.state.page,this.state.rowsPerPage);}
	
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:20,
	  prevpage:0,categorydata:[],
	  
	
    });
	
}
 handleCategorypanelOpen = (e) => {
    this.setState({ rightpanel: !this.state.rightpanel });
  };

	
  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});

 }



componentWillMount() {
	
document.title = "Isifol - Category Details";
		if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Login'
          })
		  }	  
	

		
	

  this.apicall(this.state.page,this.state.rowsPerPage); 
 



	}
	


apicall(page,rowsPerPage){
axios.get(localStorage.getItem("ISIurl")+'ajaxcategory.php?action=getall&ca_cmp_id='+localStorage.getItem("ISIcmpid")+'&ca_name='+this.state.namesearch+'&ca_mainId='+this.state.category+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  

		if(resp.data.length>0){
		
			this.setState({  
			  categorydata: resp.data, 
               			  
			   totaldata:parseInt(resp.data[0].count),
			   searchbtndisabled:false,searchbtn:"Search"
			});
			
		
     

	}
	 else{
		   this.setState({categorydata:[],totaldata:0,searchbtndisabled:false,searchbtn:"Search"});
	 }
   
    });

}


handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'desc';
  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'desc'
   
  });
};

handleChangePage = (event, newPage) => {  

    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  
  
     deleteCategory(caid){  
  
		let r = window.confirm("Do you really want to Delete?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','delete')					 
					 formData.append('ca_id',caid)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxcategory.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
				  
					
					
							});
		 }
 }

 
 Categoryaddbox(val){
        this.setState({ca_id: val },()=>{this.refs.AddCategory.Categorygetdata()});  
  
  
		 
      }
 

 
handleSearch=()=>{
	  this.setState({  
			 
			   searchbtndisabled:true,searchbtn:"Processing..."
			},()=>{  this.apicall(this.state.page,this.state.rowsPerPage); });

} 
 

 
 
 

   
 
 
 render() {
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
    
   <React.Fragment>
      <Drawer   anchor={'right'}
            open={this.state.rightpanel}
            onClose={this.handleCategorypanelOpen}
          >
		     <div className="categorypanledrawer">
			 
			 <h2><IconButton onClick={this.handleCategorypanelOpen}>
             <ChevronLeftIcon />
          </IconButton>Manage Categories</h2>
    <AddCategory ref="AddCategory" id={this.state.ca_id} updatecategory={this.updatecategoryParent}/>	
  

   <div className="searchbox">
	<ul>
	<li><p><TextField
            //variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={this.state.namesearch}
            id="namesearch"
           variant="outlined"
            name="namesearch" onChange={this.myChangeHandler}
            autoComplete="namesearch"
			placeholder="Search"
            autoFocus
			
          />
		  </p></li>


		  
		<li> <Button
            type="submit"
            halfWidth
            variant="contained" 
			disabled={this.state.searchbtndisabled}
           id="searchform" 
            className="frmSecondarybtn"
			onClick={this.handleSearch}
			endIcon={<SearchIcon />}
          >
           {this.state.searchbtn}
          </Button></li>
		  
		  </ul>
		  
  </div>
   
 
   <div className="clear"></div>

 
  

<div className="tableleft">
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  

	<TableHead>				<TableRow>

<TableCell>Name</TableCell>
<TableCell>Category</TableCell>	<TableCell></TableCell>					
				 
			</TableRow>	</TableHead>
			
                      <TableBody>

                     {this.state.categorydata.map((item,index) =>{
   return ( <React.Fragment>
 <TableRow key={index} >

	
	

<TableCell>  {item.ca_name}</TableCell>
<TableCell>{item.maincat}</TableCell>

	
<TableCell align="left">
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Categoryaddbox(item.ca_id)} }endIcon={<EditIcon />}>
Edit
</Button> 

{ item.prcount==="0" &&(
	<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.deleteCategory(item.ca_id)} }endIcon={<DeleteIcon />}>
Delete
</Button> 
)}
	
 </TableCell>

 </TableRow>


				</React.Fragment>	
				);
				
				{this.state.categorydata.length===0  &&(
				
				<TableRow  >
<TableCell colspan="5">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				)}
						 
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
          rowsPerPageOptions={[5,10]} 
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage} />    
  </Paper>
   </div>
 </div>
   </Drawer>
</React.Fragment>

		  );
  }	
   
}